/* eslint-disable @typescript-eslint/no-explicit-any */
type AnyFunc = (key: string) => any;

export function mapObject<Key extends string, Obj extends Record<Key, AnyFunc>>(
  obj: Obj,
): { [K in keyof Obj]: ReturnType<Obj[K]> } {
  let out = {};
  for (let [key, fn] of Object.entries(obj)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    out[key] = fn(key);
  }
  return out as any;
}
